import {ACCESS_TOKEN, BASE_OAUTH_REDIRECT_URL, GOOGLE_OAUTH_REDIRECT_URI, UPSTOX_OAUTH_REDIRECT_URI, X_OAUTH_REDIRECT_URI} from "../assets/constants";
import {jwtDecode} from "jwt-decode";
import {User} from "../proto/generated/identity";

export const isAuthenticated = (): boolean => {
    try {
        const token = localStorage.getItem(ACCESS_TOKEN)
        if(token !== null) {
            const decoded = jwtDecode(token)
            if(decoded.exp && decoded.exp > Math.ceil(new Date().getTime() / 1000)){
                return true
            }
            localStorage.removeItem(ACCESS_TOKEN)
        }
        return false
    } catch(e) {
        return false
    }
}
export const isAdmin = (user: User | null): boolean => {
        return !!user?.authorities?.some(auth => auth.toLowerCase() === "admin");
};

export const getRedirectUrl = (provider: string): string => {
    switch (provider) {
        case 'X':
            return X_OAUTH_REDIRECT_URI!
        case 'GOOGLE':
            return GOOGLE_OAUTH_REDIRECT_URI!
        case 'UPSTOX':
            return UPSTOX_OAUTH_REDIRECT_URI!
        default:
            return BASE_OAUTH_REDIRECT_URL!
    }
}